/**
 * API Configuration
 * Centralizes all API endpoints and WebSocket URLs
 */

// Get base URLs from environment variables with fallbacks
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8105';
const WS_BASE_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8105';

// For production, automatically use secure protocols
const isProduction = process.env.NODE_ENV === 'production';
const isSecureContext = window.location.protocol === 'https:';

// Ensure WebSocket URL uses the correct protocol
const getWebSocketUrl = () => {
  if (isProduction && isSecureContext) {
    // In production with HTTPS, ensure WSS is used
    return WS_BASE_URL.replace('ws://', 'wss://');
  }
  return WS_BASE_URL;
};

export const API_CONFIG = {
  // Base URLs
  BASE_URL: API_BASE_URL,
  WS_BASE_URL: getWebSocketUrl(),
  
  // API Endpoints
  endpoints: {
    // Auth endpoints
    auth: {
      syncUser: `${API_BASE_URL}/api/users/sync`,
      profile: `${API_BASE_URL}/api/users/profile`,
    },
    
    // Config endpoints
    config: {
      keyRequired: `${API_BASE_URL}/api/config/key-required`,
    },
    
    // Template endpoints
    templates: {
      list: `${API_BASE_URL}/api/templates`,
      create: `${API_BASE_URL}/api/templates`,
      get: (id: string) => `${API_BASE_URL}/api/templates/${id}`,
      delete: (id: string) => `${API_BASE_URL}/api/templates/${id}`,
      execute: (id: string) => `${API_BASE_URL}/api/templates/${id}/execute`,
      aiGenerate: `${API_BASE_URL}/api/templates/ai-generate`,
    },
    
    // Research endpoints
    research: {
      list: `${API_BASE_URL}/api/research-sessions`,
      get: (id: string) => `${API_BASE_URL}/api/research-sessions/${id}`,
      export: (id: string, format: 'pdf' | 'markdown') => 
        `${API_BASE_URL}/api/research-sessions/${id}/export?format=${format}`,
      delete: (id: string) => `${API_BASE_URL}/api/research-sessions/${id}`,
    },
    
    // WebSocket endpoints
    websocket: {
      research: `${getWebSocketUrl()}/research/multi-agent-chat`,
      // Use the template execution WebSocket that skips topic/question generation
      template: `${getWebSocketUrl()}/research/template-execution`,
    },
  },
  
  // Helper function to get headers with auth token
  getAuthHeaders: (token: string) => ({
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  }),
};

// Export individual URLs for backward compatibility
export const API_BASE = API_CONFIG.BASE_URL;
export const WS_BASE = API_CONFIG.WS_BASE_URL;
